import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(theme => ({
  buttonContainer: {
    padding: theme.spacing(4),
  },
}));
